import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useUpdateWhenScheduleAdvances } from '../../../data/hooks/datetimeHooks';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useSelectedSessions } from '../../../data/hooks/schedule/useSelectedSessions';
import { useIsValidWaitingRoomSessionFilter } from '../../../data/hooks/schedule/useIsValidWaitingRoomSessionFilter';
import Icon from '../../elements/icons/Icon';
import LoadParticipants from '../../loaders/LoadParticipants';
import LoadProgram from '../../loaders/LoadProgram';
import ErrorBoundary from '../../validate/ErrorBoundary';
import WaitWhileBusy from '../../WaitWhileBusy';
import NextProgram from '../common/NextProgram';
import { useNextSession, useSessionInProgress } from '../hooks';
import SidePanelWrapper from '../SidePanelWrapper';
import WaitingRoomProgram from './common/WaitingRoomProgram';
import WaitingRoomSpeaker from './common/WaitingRoomSpeaker/WaitingRoomSpeaker';
import WaitingRoomStream from './common/WaitingRoomStream';
import WaitingRoomTimer from './common/WaitingRoomTimer';
import './EventWaitingRoom.scss';
import ParticipantBubbles from './ParticipantBubbles/ParticipantBubbles';

const EventWaitingRoom = (props) => {
    const { isMaximized } = props,
        event = useEvent(),
        selectedSessions = useSelectedSessions(event.id),
        isValidWaitingRoomSession = useIsValidWaitingRoomSessionFilter(
            event.id
        ),
        currentSession = useSessionInProgress(event.id, {
            filter: (session) =>
                isValidWaitingRoomSession(session, selectedSessions),
        }),
        nextSession = useNextSession(event.id, {
            filter: (session) =>
                isValidWaitingRoomSession(session, selectedSessions),
        }),
        { primary_color } = event.settings,
        fullScreenStyle = isMaximized ? { visibility: 'visible' } : undefined,
        closeFullScreenEl = (
            <button
                className={'closeFullScreen'}
                style={{ background: primary_color }}
                onClick={handleCloseSidePanel}>
                <Icon size={20} src='img/chevron-left-white.png' />
            </button>
        ),
        [hasNextProgram, setHasNextProgram] = useState(false);

    // console.log('Rerender WAITING ROOM', moment().format(), currentSession?.name);
    useUpdateWhenScheduleAdvances(event.id);

    let activeSession;
    if (isValidWaitingRoomSession(currentSession, selectedSessions))
        activeSession = currentSession;
    else if (isValidWaitingRoomSession(nextSession, selectedSessions))
        activeSession = nextSession;

    useEffect(() => {
        if (!currentSession && hasNextProgram) {
            setHasNextProgram(false);
        }
    }, [currentSession]);

    function handleCloseSidePanel() {
        app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
    }

    if (!activeSession) return null;

    return (
        <SidePanelWrapper>
            <div
                className={[
                    'EventWaitingRoom',
                    hasNextProgram ? 'nextProgramActive' : '',
                ].join(' ')}
                style={{ ...fullScreenStyle }}>
                <div className='infoSection'>
                    {closeFullScreenEl}
                    {activeSession ? (
                        <>
                            <WaitingRoomStream
                                event={event}
                                session={activeSession}
                            />
                            <WaitingRoomProgram
                                event={event}
                                session={activeSession}
                            />
                            <WaitingRoomSpeaker
                                event={event}
                                session={activeSession}
                            />
                            <div>
                                <WaitingRoomTimer
                                    event={event}
                                    currentSession={currentSession}
                                    nextSession={nextSession}
                                />
                                {currentSession ? (
                                    <NextProgram
                                        event={event}
                                        onChangeVisibility={setHasNextProgram}
                                    />
                                ) : null}
                            </div>
                        </>
                    ) : null}
                </div>
                <ParticipantBubbles event={event} session={activeSession} />
            </div>
        </SidePanelWrapper>
    );
};

export default (props) => {
    const params = useParams(),
        event = useEvent(params.eventId);
    if (event) {
        return (
            <LoadParticipants eventId={params.eventId}>
                <LoadProgram eventId={params.eventId}>
                    <WaitWhileBusy alt={<span />}>
                        <ErrorBoundary altComponent={false}>
                            <EventWaitingRoom {...props} />
                        </ErrorBoundary>
                    </WaitWhileBusy>
                </LoadProgram>
            </LoadParticipants>
        );
    } else {
        return null;
    }
};
